import {
  WISHLIST_SEND_TO_EMAIL,
  WISHLIST_HIDE_EMAIL_FORM
} from "../constants/hwk";
import { SUCCESS_MESSAGE, ERROR_MESSAGE } from "../../store/constants/general";

import { put, call, takeLatest, select } from "redux-saga/effects";
import { getWishlistEmailRequest } from "../selectors/advisor";
import { API } from "../../api";
import { i18n } from "../../locale";

const t = i18n.getFixedT();

// Params
const getWishlistEmailParams = state => {
  return getWishlistEmailRequest(state);
};

function* requestWishlistEmail(action) {
  try {
    const params = yield select(getWishlistEmailParams);
    yield call(API.requestWishlistEmail, params);

    yield put({
      type: SUCCESS_MESSAGE,
      message: t("wishlist:send_to_email_success")
    });
    yield put({ type: WISHLIST_HIDE_EMAIL_FORM });
  } catch (e) {
    console.log("ERROR in requestWishlistEmail", e.message);
    yield put({ type: ERROR_MESSAGE, message: e.message });
  }
}

export default function* rootSaga() {
  yield takeLatest(WISHLIST_SEND_TO_EMAIL, requestWishlistEmail);
}
